module.exports = __webpack_public_path__ + "img/P37-en.eaf38bd6.png";